/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSqlConnectorStatusFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type SqlConnectorStatus } from '../../../models/index.js';
// @ts-ignore
import { EndpointsRequestBuilderRequestsMetadata, type EndpointsRequestBuilder } from './endpoints/index.js';
// @ts-ignore
import { HeartbeatRequestBuilderRequestsMetadata, type HeartbeatRequestBuilder } from './heartbeat/index.js';
// @ts-ignore
import { SyncRunsRequestBuilderRequestsMetadata, type SyncRunsRequestBuilder } from './syncRuns/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/sql-connector/{connectorId}
 */
export interface WithConnectorItemRequestBuilder extends BaseRequestBuilder<WithConnectorItemRequestBuilder> {
    /**
     * The endpoints property
     */
    get endpoints(): EndpointsRequestBuilder;
    /**
     * The heartbeat property
     */
    get heartbeat(): HeartbeatRequestBuilder;
    /**
     * The syncRuns property
     */
    get syncRuns(): SyncRunsRequestBuilder;
    /**
     * Returns one connector's registration details together with the status and version it last reported, and the lastHeartbeatAt timestamp that tells you whether it is still running — nothing flips a connector to Offline on its own, so judge liveness from that timestamp. The lookup is scoped to the caller's organization, so a connector belonging to another organization is reported as not found rather than as forbidden.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SqlConnectorStatus>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SqlConnectorStatus | undefined>;
    /**
     * Returns one connector's registration details together with the status and version it last reported, and the lastHeartbeatAt timestamp that tells you whether it is still running — nothing flips a connector to Offline on its own, so judge liveness from that timestamp. The lookup is scoped to the caller's organization, so a connector belonging to another organization is reported as not found rather than as forbidden.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithConnectorItemRequestBuilderUriTemplate = "{+baseurl}/api/sql-connector/{connectorId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithConnectorItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithConnectorItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    endpoints: {
        requestsMetadata: EndpointsRequestBuilderRequestsMetadata,
    },
    heartbeat: {
        requestsMetadata: HeartbeatRequestBuilderRequestsMetadata,
    },
    syncRuns: {
        requestsMetadata: SyncRunsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithConnectorItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithConnectorItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSqlConnectorStatusFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
